/* ═════════════════════════════════
   LIFESTYLE GALLERY LIGHTBOX — Avyona Theme
   ══════════════════════════════════ */

(function() {
  'use strict';

  // Current image index for navigation
  let currentImageIndex = 0;

  // Initialize lightbox when DOM is ready
  function initLightbox() {
    const lightbox = document.getElementById('lgLb');
    if (!lightbox) {
      console.warn('Lifestyle Gallery: Lightbox element not found');
      return;
    }

    const lightboxImg = document.getElementById('lgLbImg');
    const lightboxCounter = document.getElementById('lgLbCounter');
    const lightboxCaption = document.getElementById('lgLbCaption');
    
    if (!lightboxImg || !lightboxCounter || !lightboxCaption) {
      console.warn('Lifestyle Gallery: Lightbox elements not found');
      return;
    }

    // Setup event listeners
    setupEventListeners(lightbox);
    
    // Initialize gallery data from DOM
    updateGalleryData();
  }

  // Extract gallery data from DOM attributes
  function updateGalleryData() {
    const galleryItems = document.querySelectorAll('.somo-lgallery-item');
    const galleryData = [];
    
    galleryItems.forEach((item, index) => {
      const img = item.querySelector('img');
      const label = item.querySelector('.somo-lgallery-item-label');
      
      if (img && label) {
        galleryData.push({
          src: img.src,
          srcset: img.srcset,
          sizes: img.sizes,
          alt: img.alt,
          caption: label.textContent.trim()
        });
      }
    });
    
    return galleryData;
  }

  // Setup event listeners
  function setupEventListeners(lightbox) {
    // Close lightbox when clicking outside
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('open')) return;

      switch(e.key) {
        case 'Escape':
          closeLightbox();
          break;
        case 'ArrowLeft':
          navigateLightbox(-1);
          break;
        case 'ArrowRight':
          navigateLightbox(1);
          break;
      }
    });

    // Touch gestures for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    lightbox.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    });

    lightbox.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          navigateLightbox(1); // Swipe left, go to next
        } else {
          navigateLightbox(-1); // Swipe right, go to previous
        }
      }
    }
  }

    // Update gallery data when images load
  function setupGalleryObserver() {
    const galleryGrid = document.querySelector('.somo-lgallery-grid');
    if (galleryGrid) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            updateGalleryData();
          }
        });
      });
      observer.observe(galleryGrid, {
        childList: true,
        subtree: true
      });
    }
  }

  // Show specific image in lightbox
  function showImage(index) {
    const galleryData = updateGalleryData();
    
    if (index < 0 || index >= galleryData.length) {
      return;
    }
    
    const imageData = galleryData[index];
    const lightboxImg = document.getElementById('lgLbImg');
    const lightboxCounter = document.getElementById('lgLbCounter');
    const lightboxCaption = document.getElementById('lgLbCaption');
    
    if (lightboxImg && lightboxCounter && lightboxCaption) {
      // Update image with responsive attributes
      lightboxImg.src = imageData.src;
      if (imageData.srcset) {
        lightboxImg.srcset = imageData.srcset;
      }
      if (imageData.sizes) {
        lightboxImg.sizes = imageData.sizes;
      }
      lightboxImg.alt = imageData.alt;
      
      // Update counter and caption
      lightboxCounter.textContent = `${index + 1} / ${galleryData.length}`;
      lightboxCaption.textContent = imageData.caption;
      
      // Store current index for navigation
      currentImageIndex = index;
    }
  }

  // Open lightbox
  function openLightbox(index) {
    const lightbox = document.getElementById('lgLb');
    const lightboxImg = document.getElementById('lgLbImg');
    if (!lightbox || !lightboxImg) return;

    showImage(index);
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling

    // Focus management for accessibility
    lightbox.setAttribute('aria-hidden', 'false');
    lightboxImg.focus();
  }

  // Close lightbox
  function closeLightbox() {
    const lightbox = document.getElementById('lgLb');
    if (!lightbox) return;

    lightbox.classList.remove('open');
    document.body.style.overflow = ''; // Restore background scrolling

    // Focus management for accessibility
    lightbox.setAttribute('aria-hidden', 'true');
  }

  // Navigate lightbox
  function navigateLightbox(direction) {
    const galleryData = updateGalleryData();
    if (!galleryData.length) return;
    
    const currentImg = document.getElementById('lgLbImg');
    const currentSrc = currentImg ? currentImg.src : '';
    const currentIndex = galleryData.findIndex(item => item.src === currentSrc);
    
    let newIndex = currentIndex + direction;
    if (newIndex < 0) newIndex = galleryData.length - 1;
    if (newIndex >= galleryData.length) newIndex = 0;
    
    showImage(newIndex);
  }

  // Global functions for onclick handlers
  window.openLb = openLightbox;
  window.closeLb = closeLightbox;
  window.lbNav = navigateLightbox;

  // Initialize when DOM is ready
  function initializeGallery() {
    initLightbox();
    setupGalleryObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGallery);
  } else {
    initializeGallery();
  }

})();
